import { preprocess } from '@artica/assets';
import { RepeatWrapping } from 'three';

preprocess('cloud', function preprocessCloud(cloud) {
  cloud.wrapS = cloud.wrapT = RepeatWrapping;
  return cloud;
});

preprocess('lav', function preprocessLav(lav) {
  lav.wrapS = lav.wrapT = RepeatWrapping;
  return lav;
});